// Keys of the shared ClientCertificatesTable (list, row composition, refund
// dialog). Not a page bundle — spread into every locale whose page mounts the
// table, so the wording can never drift between them.
export const CLIENT_CERTIFICATES_TABLE = {
  en: {
    Code: 'Code',
    Buyer: 'Buyer',
    Status: 'Status',
    'Sale location': 'Sale location',
    'Sold at': 'Sold at',
    'Search by code': 'Search by code',
    'Sold from': 'Sold from',
    'Sold till': 'Sold till',
    'By whom used': 'By whom used',
    'Not used': 'Not used',
    'Valid until': 'Valid until',
    'No expiry': 'No expiry',
    'Face value': 'Face value',
    Remainder: 'Remainder',
    Remaining: 'Remaining',
    Issued: 'Issued',
    Note: 'Note',
    'No certificate with this code': 'No certificate with this code',
    certificate_status_draft: 'Draft',
    certificate_status_active: 'Active',
    certificate_status_fully_redeemed: 'Fully redeemed',
    certificate_status_expired: 'Expired',
    certificate_status_refunded: 'Refunded',
    Refund: 'Refund',
    'Refund the remainder': 'Refund the remainder',
    'Only the un-redeemed remainder is refunded':
      'Only the un-redeemed remainder is refunded',
    'Refund method': 'Refund method',
    'Pay out from cash register': 'Pay out from cash register',
    "Credit to the buyer's deposit": "Credit to the buyer's deposit",
    'From cash register': 'From cash register',
    'Refund reason': 'Refund reason',
  },
  uk: {
    Code: 'Код',
    Buyer: 'Покупець',
    Status: 'Статус',
    'Sale location': 'Локація продажу',
    'Sold at': 'Продано',
    'Search by code': 'Пошук за кодом',
    'Sold from': 'Продано з',
    'Sold till': 'Продано до',
    'By whom used': 'Ким використано',
    'Not used': 'Не використано',
    'Valid until': 'Діє до',
    'No expiry': 'Безстроково',
    'Face value': 'Номінал',
    Remainder: 'Залишок',
    Remaining: 'Залишок',
    Issued: 'Видано',
    Note: 'Примітка',
    'No certificate with this code': 'Сертифіката з таким кодом немає',
    certificate_status_draft: 'Чернетка',
    certificate_status_active: 'Активний',
    certificate_status_fully_redeemed: 'Повністю використаний',
    certificate_status_expired: 'Прострочений',
    certificate_status_refunded: 'Повернений',
    Refund: 'Повернути',
    'Refund the remainder': 'Повернути залишок',
    'Only the un-redeemed remainder is refunded':
      'Повертається лише невикористаний залишок',
    'Refund method': 'Спосіб повернення',
    'Pay out from cash register': 'Видати з каси',
    "Credit to the buyer's deposit": 'Зарахувати на депозит покупця',
    'From cash register': 'З каси',
    'Refund reason': 'Причина повернення',
  },
};
